const FruitActionTypes = {
  SET_FRUITS: "SET_FRUITS",
  SET_STORE_STATUS: "SET_STORE_STATUS",
  SET_FRUIT_SLIDE_MODAL_STATUS: "SET_FRUIT_SLIDE_MODAL_STATUS",
  SET_FRUIT_SLIDE_IMAGES: "SET_FRUIT_SLIDE_IMAGES",
};

export default FruitActionTypes;
